import React from "react";
import { Link } from "react-router-dom";

function LinkToCreateAccount(props) {
  let text, altText, path, altPath, linkText, altLinkText;

  if (props.onRegister) {
    if (props.isTeacher) {
      path = "/Login"
      altPath = "/RegisterCollege"
      altText = "From an institution?"
    }
    else if (props.isInst) {
      path = "/LoginAsInstitution"
      altPath = "/TeacherOption"
      altText = "Are you a teacher?"
    }
    else {
      path = "/Login"
    }
    text = "Already have an account?";
    linkText = "Sign in";
    altLinkText = "Sign up here"
  } else {
    text = "New User?";
    path = "/RegisterOption";
    linkText = "Create Account";
  }

  return (
    <>
      <div className="w-100 text-center mt-3">
        {text}
      &nbsp;
      <u>
          <Link to={path}>{linkText + " >>"}</Link>
        </u>
      </div>
      {!!altText &&
        <div className="w-100 text-center">
          {altText}
        &nbsp;
        <u>
            <Link to={altPath}>{altLinkText + " >>"}</Link>
          </u>
        </div>
      }
    </>
  );
}

export default LinkToCreateAccount;
